import { window } from './browser';
import { LocalStorage } from './storage';

export const STORED_QUERY_KEY = 'stored-query';

export const host = window?.location.origin ?? '';

export const basePath = process.env.BASE_PATH || '/book-room';

export const clientUrl = `${host}${basePath}`;

export const getStoredQuery = () => LocalStorage.get(STORED_QUERY_KEY);

export const saveCurrentQuery = () => {
  const allParams = new URLSearchParams(window?.location.search);
  allParams.delete('code');
  const params = allParams.toString();
  LocalStorage.set(STORED_QUERY_KEY, params ?? '');
};

export const removeStoredQuery = () => LocalStorage.remove(STORED_QUERY_KEY);

export const handleStoredQuery = () => {
  const storedQuery = getStoredQuery();

  if (!window || !storedQuery) return;

  removeStoredQuery();

  window.location.search = storedQuery;
};
